// extracted by mini-css-extract-plugin
export default {"loader":"AreaLoader_loader__UbLEm","fade":"AreaLoader_fade__YMscb","text":"AreaLoader_text__zjDWK","c2":"AreaLoader_c2__9506F"};